import { IInvoicingConfig } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const getInvoicingConfigForPayer =
  async (): Promise<IInvoicingConfig> => {
    const { data } = await servicePayments.get(`/invoicing-config`);
    return data;
  };
